import { fontFamily } from "@/styles/font";
import React from "react";
import styled from "styled-components";

interface StarRatingProps {
    rating: number;
    onRatingChange: (rating: number) => void;
}

const StarRating = ({ rating, onRatingChange }: StarRatingProps) => {
    return (
        <StarContainer>
            <StarWrapper>
                {[1, 2, 3, 4, 5].map((star) => (
                    <StarButton
                        key={star}
                        type="button"
                        onClick={() => onRatingChange(star)}
                        $isActive={star <= rating}
                    >
                        <img src="/icon/star.png" alt={`별점 ${star}점`} />
                    </StarButton>
                ))}
            </StarWrapper>
            <RatingText>
                {rating}점 / {getRatingText(rating)}
            </RatingText>
        </StarContainer>
    );
};

const getRatingText = (rating: number) => {
    switch (rating) {
        case 5:
            return "다시 마시고 싶어요";
        case 4:
            return "맛있어요";
        case 3:
            return "보통이에요";
        case 2:
            return "별로예요";
        case 1:
            return "다시는 마시지 않을래요";
        default:
            return "";
    }
};

export default StarRating;

const StarContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0;
    gap: 8px;
    width: 100%;
    height: 67px;
`;

const StarWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0;
    gap: 3px;
    width: 212px;
    height: 40px;
`;

const StarButton = styled.button<{ $isActive: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    img {
        width: 40px;
        height: 40px;
        opacity: ${(props) => (props.$isActive ? 1 : 0.3)};
    }
`;

const RatingText = styled.p`
    font-family: ${fontFamily.base};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    color: #414141;
    margin-left: 7px;
`;
